export default __webpack_public_path__ + "static/media/official.e29c8190.mov";